export default __webpack_public_path__ + "static/media/weight-loss_gym.7e4a8226.jpg";